import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { CLPrescriptionColumn } from './CLPrescriptionColumn.js';
import { useCLEcommContext } from '../../../../context/CLEcommContext.js';
import { useFetchCLByPrescription } from '../../../../hooks/use-fetch-cl-by-prescription.js';

const CLPrescriptionColumnContainer = (props)=>{
    const { eyeSideId  } = props;
    const { actions , state , selectors  } = useCLEcommContext();
    const { prescription  } = state.configurations[eyeSideId];
    const hasNonrecoverableError = selectors.hasNonrecoverableError(state);
    const fetchCLByPrescription = useFetchCLByPrescription({
        eyeSide: eyeSideId
    });
    // Get column UI validation state for this eye side
    const { columnCheckboxes  } = state.configurator;
    const { isValid , isEnabled: isEnabled1  } = state.configurator[eyeSideId];
    React.useEffect(()=>{
        if (!isValid || !isEnabled1 || hasNonrecoverableError) {
            return;
        }
        fetchCLByPrescription(prescription);
    }, [
        fetchCLByPrescription,
        prescription,
        isEnabled1,
        isValid,
        hasNonrecoverableError
    ]);
    const handleAttributeChange = React.useCallback((attribute, value, eyeSide)=>actions.updatePrescriptionAttribute(eyeSide, attribute, value)
    , []);
    const handleCheckboxChange = React.useCallback((isEnabled, eyeSide)=>actions.updateColumnCheckbox(eyeSide, isEnabled)
    , []);
    return /*#__PURE__*/ React.createElement(CLPrescriptionColumn, swcHelpers.extends({}, props, {
        isEnabled: isEnabled1,
        showCheckboxError: columnCheckboxes.showError,
        onAttributeChange: handleAttributeChange,
        onCheckboxChange: handleCheckboxChange
    }));
};

export { CLPrescriptionColumnContainer };
//# sourceMappingURL=CLPrescriptionColumnContainer.js.map
